import { render, staticRenderFns } from "./MmfButton.vue?vue&type=template&id=7ebc9894&"
import script from "./MmfButton.vue?vue&type=script&lang=js&"
export * from "./MmfButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports